import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-promotion-category-form',
  templateUrl: './promotion-category-form.component.html',
  styleUrls: ['./promotion-category-form.component.scss']
})
export class PromotionCategoryFormComponent {

  @ViewChild("f", {static: true}) f:NgForm;

  public data:any = {
    title: '',
    status: "1"
  };


  constructor(private http: HttpService, private activatedRoute: ActivatedRoute) { 
    this.activatedRoute.params.subscribe(params => {
      if(params['promotion_category_uuid']) {
        this.init(params['promotion_category_uuid']);
      }
    });
  }

  async init(promotion_category_uuid = null) {
    if(!promotion_category_uuid) {
      return
    }
    this.data = await this.http.post('/admin/app/promotion-category/get', {promotion_category_uuid});
  }

  upload(data:any, key:string, single = false) {
    this.data[key] = (single) ? data[0] : data
  }

  delete(data:any, key:string) {
    this.data[key] = data
  }

  async submit() {

    if(this.f.invalid) {
      return;
    }

    const s = await this.http.post("/admin/app/promotion-category/update", this.data)

    if (s['status']) {
      this.http.notify("Promotion category update successfully.")
      this.http.naviBack();
    }
  }
}
